import React, { useEffect, useRef } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
// import * as d3 from 'd3';
import { listOfDatesByDay } from 'utils/dates';
import { filterObject } from 'utils/helpers';
import widgetRender from './bei-light';
import SliderComponent from '../FeedBackSynthesis/Slider';

function updateChart(widgetObject, dataFilteringRule) {
  widgetObject.detailProperties.dataFiltering = dataFilteringRule;

  widgetRender(widgetObject, 'updateData');
}

const ChartWeakness = ({ data, loading, error }) => {
  const d3svg = useRef(false);

  /*   useEffect(() => {
    }, [loading]); */

  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'barchart', // barchart, pie, linechart
      orientation: 'vertical', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 50, right: 20, bottom: 50, left: 180 },
      size: { width: '100%', height: '100%' },
      minSize: { width: 200, height: 200 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: true,
      dimensionFields: ['weakness', 'investorType'],
      dimensionFieldsDatatype: ['text', 'text'],
      dimensionFieldsLabel: ['weakness', 'investorType'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [
        [
          'Profitability',
          'Competition',
          'Sustainability',
          'Scale',
          'Leverage',
          'Other'
        ],
        [
          'Venture Capital',
          'PE',
          'SWF',
          'Mutual Fund',
          'Pension Fund',
          'Hedge Fund',
          'Corporate',
          'Holding Company'
        ]
      ],
      dimensionFieldsSortOrder: [null],
      multiDimensionStyle: 'stacked', // grouped, stacked, diverging, bullet (for bullet & diverging multiDimensionStyle , 2nd axis must have 2 values max !!!)
      calculationFields: ['count'],
      calculationFieldsLabel: ['count'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.2'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['investorType'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: [
            'Venture Capital',
            'PE',
            'SWF',
            'Mutual Fund',
            'Pension Fund',
            'Hedge Fund',
            'Corporate',
            'Holding Company'
          ],
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: [
            '#002380',
            '#1E90A6',
            '#75C8C4',
            '#A3E3C0',
            '#CFFCD2',
            '#F8FEB1',
            '#F2ED88',
            '#FCECBD'
          ],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      XYChart: {
        includeOrigin: true, // used for barchart / linechart
        linearGridline: false,
        categoricalGridline: false,
        linearAxis: false,
        linearAxisLine: false,
        linearAxisLabel: false,
        linearAxisLabelFormat: '.0%',
        linearAxisTick: false,
        linearAxisMinMaxExtendFactor: null,
        linearAxisTicksNumber: 3,
        linearAxisMinMaxOnDataset: true,
        categoricalAxis: true,
        categoricalAxisLabel: true,
        categoricalAxisTick: false,
        categoricalAxisLabelFormat: '%b %e',
        categoricalAxisLabelHPadding: -10,
        categoricalAxisLabelTextWrapWidth: 200,
        categoricalAxisLabelTextWrapLineHeight: 1.2,
        categoricalAxisLabelTextAnchor: 'end',
        barPadding: 0.4, // value between 0 and 1
        barRadius: 0, // value in px
        barRadiusPosition: 'all', // all, top, bottom
        barGroupPadding: 0.7, // value between 0 and 1
        barBandwithReduction: 0
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#979797',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 0
      },
      gridline: {
        padding: -10,
        showExtend: true,
        dashArray: '10 10',
        width: 0.5,
        color: '#979797',
        altColor: '#000000',
        opacity: 0.8
      },
      title: {
        visible: true,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '18px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG:
          "<text style='text-anchor:start'><tspan dy='0.7em'>WEAKNESSES</tspan></text>"
      },
      tooltip: {
        active: true,
        hPosition: 'shape', // shape, mouse, fixe
        vPosition: 'shape',
        hRelPosition: 'center',
        vRelPosition: 'up',
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 0,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='10' y2='70' style='stroke : [shapeColor];stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>Investor type : [investorType]</tspan><tspan x='25' y='62'>Value : [count]</tspan></text></g>",
        variableFormat: {
          date: { datatype: 'date', formatIn: '%d/%m/%y', formatOut: '%B %e' }
        },
        tooltipSpecificFn: null
      },
      label: {
        visible: false
      },
      animation: {
        active: false,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: 'ChartWeakness',
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  function test2(data, action) {
    widgetRender(widgetProperties_US342, action);

    // d3.select('#b1').on('click', function () {
    //   updateChart(widgetProperties_US342, {
    //     active: true,
    //     restrictionColumn: ['date'],
    //     restrictionColumnDatatype: ['date'],
    //     restrictionColumnFormat: ['%d/%m/%y'],
    //     restrictionColumnToValue: ['13/07/20'],
    //     restrictionColumnSign: ['<=']
    //   });
    // });
    // d3.select('#b2').on('click', function () {
    //   updateChart(widgetProperties_US342, {
    //     active: true,
    //     restrictionColumn: ['date'],
    //     restrictionColumnDatatype: ['date'],
    //     restrictionColumnFormat: ['%d/%m/%y'],
    //     restrictionColumnToValue: ['20/07/20'],
    //     restrictionColumnSign: ['<=']
    //   });
    // });
    // d3.select('#b3').on('click', function () {
    //   updateChart(widgetProperties_US342, null);
    // });
  }

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init');
      }
    } else d3svg.current = true;
  }, [data, test2]);

  const handleChangeChart = (e, v) => {
    updateChart(widgetProperties_US342, filterObject(listOfDatesByDay()[v]));
  };

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id="ChartWeakness"
        role="img"
        style={{ width: '100%', height: '300px' }}>
        <SliderComponent handleChange={handleChangeChart} />
        {loading && (
          <h6>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red' }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartWeakness;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
